import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

export function LockScreen({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:56px 14px 34px;display:flex;flex-direction:column;background:linear-gradient(180deg,rgba(10,12,18,.25) 0%,rgba(10,12,18,.55) 60%,rgba(10,12,18,.8) 100%),url(/assets/lock-michael.jpg) center/cover no-repeat")}>
      <div style={sx("text-align:center;padding:24px 0 32px;display:flex;flex-direction:column;gap:2px;text-shadow:0 1px 12px rgba(0,0,0,.5)")}>
        <span style={sx("font-size:var(--fs-md);opacity:.9")}>
          Monday, 17 August
        </span>
        <span style={sx("font-size:72px;font-weight:var(--fw-bold);letter-spacing:var(--ls-2xs);line-height:80px")}>
          9:41
        </span>
      </div>
      <div style={sx("display:flex;flex-direction:column;gap:10px")}>
        {v.mAlertPush ? (
          <>
            <Hov as="button" onClick={v.openAlertsFromLock} style={sx("text-align:left;padding:14px 16px;border-radius:var(--radius-lg);background:rgba(255,255,255,.1);backdrop-filter:blur(16px);border:1px solid rgba(255,255,255,.12);color:#fff;font-family:inherit;cursor:pointer;display:flex;gap:12px;animation:gpop 250ms var(--ease-out)")} hoverStyle={sx("background:rgba(255,255,255,.16)")}>
              <span style={sx("width:38px;height:38px;flex:none;border-radius:10px;background:var(--app-icon-surface);display:flex;align-items:center;justify-content:center;box-shadow:var(--shadow-app-icon-feature)")}>
                <span style={sx("width:22px;height:22px;background:var(--color-blue-600);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
                <span style={sx("display:flex;justify-content:space-between;align-items:baseline")}>
                  <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-bold)")}>
                    NordVPN
                  </span>
                  <span style={sx("font-size:var(--fs-2xs);opacity:.7")}>
                    now
                  </span>
                </span>
                <span style={sx("font-size:var(--fs-sm);line-height:20px")}>
                  {v.mPushText}
                </span>
              </span>
            </Hov>
          </>
        ) : null}
        {v.mQuietLock ? (
          <>
            <div style={sx("text-align:center;font-size:var(--fs-xs);color:rgba(255,255,255,.5)")}>
              No notifications
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}
